import React from 'react';
import styled from 'styled-components';
import { breakpoints, spacing, themeLight } from '@naf/theme';
import { Tooltip } from '@naf/parts';
import { Text, TextVariant } from '@naf/text';
import { nafColor } from '@nafcore/theme';
export const SocialProof = ({
  title,
  rating,
  totalNumberOfRatings,
  tooltip,
  children,
  caption,
  linkComponent,
  advancedImage,
  img
}) => {
  const renderStars = () => {
    const maxStars = 5;
    const ratingValue = rating || 0;
    const stars = [];
    const starSize = 18;
    for (let i = 1; i <= maxStars; i++) {
      if (i <= Math.floor(ratingValue)) {
        // Full star
        stars.push( /*#__PURE__*/React.createElement(StarIcon, {
          key: i,
          size: starSize,
          $filled: true
        }));
      } else if (i === Math.ceil(ratingValue) && ratingValue % 1 !== 0) {
        // Partially filled star
        const fraction = ratingValue % 1;
        stars.push( /*#__PURE__*/React.createElement(StarIcon, {
          key: i,
          size: starSize,
          $partial: fraction
        }));
      } else {
        // Empty star
        stars.push( /*#__PURE__*/React.createElement(StarIcon, {
          key: i,
          size: starSize
        }));
      }
    }
    return stars;
  };
  return /*#__PURE__*/React.createElement(SocialProofWrapper, null, title && /*#__PURE__*/React.createElement(StyledTitle, {
    tag: "span",
    $rating: rating,
    variant: TextVariant.SubHeader
  }, title), rating && /*#__PURE__*/React.createElement(RatingContainer, null, /*#__PURE__*/React.createElement(RatingText, {
    tag: "span",
    variant: TextVariant.BodyText
  }, rating.toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).replace('.', ',')), renderStars(), totalNumberOfRatings && /*#__PURE__*/React.createElement(RatingText, {
    tag: "span",
    variant: TextVariant.BodyText
  }, "(", totalNumberOfRatings, ")"), tooltip && /*#__PURE__*/React.createElement(StyledTooltip, {
    text: tooltip
  })), /*#__PURE__*/React.createElement(TextContent, {
    tag: "span"
  }, children), /*#__PURE__*/React.createElement(CaptionContainer, null, advancedImage && advancedImage, img && !advancedImage && /*#__PURE__*/React.createElement("img", {
    src: img?.src,
    alt: img?.alt
  }), /*#__PURE__*/React.createElement(LinkContainer, null, caption && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    variant: TextVariant.BodyTextSubHeader
  }, caption), linkComponent)));
};
export default SocialProof;
const StyledTitle = styled(Text).withConfig({
  displayName: "SocialProof__StyledTitle",
  componentId: "sc-17oyw60-0"
})(["margin-bottom:", ";"], ({
  $rating
}) => $rating ? `-${spacing.space4}` : '0');
const SocialProofWrapper = styled.div.withConfig({
  displayName: "SocialProof__SocialProofWrapper",
  componentId: "sc-17oyw60-1"
})(["display:flex;flex-direction:column;border:1px solid ", ";border-radius:2px;padding:", ";@media (max-width:", "){padding:", " ", ";}"], themeLight.border.default, spacing.space32, breakpoints.m, spacing.space32, spacing.space16);
const RatingContainer = styled.div.withConfig({
  displayName: "SocialProof__RatingContainer",
  componentId: "sc-17oyw60-2"
})(["display:flex;align-items:center;flex-direction:row;"]);
const RatingText = styled(Text).withConfig({
  displayName: "SocialProof__RatingText",
  componentId: "sc-17oyw60-3"
})(["margin:", " ", " 0 0;"], spacing.space4, spacing.space8);
const StyledTooltip = styled(Tooltip).withConfig({
  displayName: "SocialProof__StyledTooltip",
  componentId: "sc-17oyw60-4"
})([""]);
const StarIconWrapper = styled.div.withConfig({
  displayName: "SocialProof__StarIconWrapper",
  componentId: "sc-17oyw60-5"
})(["position:relative;display:inline-block;margin-right:", ";svg{display:block;width:18px;height:18px;}"], spacing.space4);
const StarIcon = ({
  size,
  $filled,
  $partial
}) => /*#__PURE__*/React.createElement(StarIconWrapper, null, /*#__PURE__*/React.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 .587l3.668 7.431 8.2 1.192-5.934 5.78 1.4 8.17L12 18.897l-7.334 3.863 1.4-8.17L.132 9.21l8.2-1.192L12 .587z",
  fill: $filled ? nafColor.signature.yellow : $partial ? `url(#partial-${$partial})` : nafColor.neutral.neutral3
}), $partial && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: `partial-${$partial}`,
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: `${$partial * 100}%`,
  stopColor: nafColor.signature.yellow
}), /*#__PURE__*/React.createElement("stop", {
  offset: `${$partial * 100}%`,
  stopColor: nafColor.neutral.neutral3
})))));
const TextContent = styled(Text).withConfig({
  displayName: "SocialProof__TextContent",
  componentId: "sc-17oyw60-6"
})(["font-style:italic;font-size:1.125rem;line-height:2rem;margin-bottom:", ";"], spacing.space24);
const CaptionContainer = styled.div.withConfig({
  displayName: "SocialProof__CaptionContainer",
  componentId: "sc-17oyw60-7"
})(["display:flex;flex-direction:row;align-items:center;img{width:70px;height:70px;border-radius:50%;border:1px solid ", ";margin-right:", ";}"], themeLight.border.default, spacing.space16);
const LinkContainer = styled.div.withConfig({
  displayName: "SocialProof__LinkContainer",
  componentId: "sc-17oyw60-8"
})(["display:flex;flex-direction:column;"]);
//# sourceMappingURL=SocialProof.js.map